import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import Feedback from "react-bootstrap/esm/Feedback";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import axiosApi from "../../axios/axios-api";
import { LogoPetroprix } from "../ui/LogoPetroprix";
import { useDispatch, useSelector } from "react-redux";
import { startLogout } from "../../store/auth";
import { ValidateToken } from "../../helpers/validateToken";

const URL_EDITAR_LIMITES_FLOTA = "flotas/limites/";

export function ModalLimitesCuenta(props) {
  const [validated, setValidated] = useState(false);
  const { token, flotaActiva } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const { idClienteFlota, ...modalProps } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    max_imp_red: "1000",
    max_op_red: "250",
    motive: "",
  });

  const [validateForm, setValidateForm] = useState({
    max_imp_red: false,
    max_op_red: false,
    motive: false,
  });

  const setDailyLimits = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setValidated(false);
    setLoading(true);

    const newValidateForm = {
      max_imp_red: formData.max_imp_red !== "",
      max_op_red: formData.max_op_red !== "",
      motive: formData.motive !== "",
    };

    setValidateForm(newValidateForm);

    if (Object.values(newValidateForm).some((value) => value === false)) {
      const campoInvalido = Object.keys(newValidateForm).find(
        (key) => newValidateForm[key] === false
      );
      toast(
        t(`flotas.modal.limites.form.validation.${campoInvalido}.invalid`),
        {
          icon: <LogoPetroprix />,
        }
      );
      setValidated(true);
      setLoading(false);
      return;
    }

    setValidated(true);

    const dataSend = {
      max_imp_red: parseInt(formData.max_imp_red, 10),
      max_op_red: parseInt(formData.max_op_red, 10),
      motive: formData.motive,
    };

    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.put(
          URL_EDITAR_LIMITES_FLOTA + idClienteFlota,
          dataSend,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        if (response?.data?.code === 200) {
          props.onHide(true);
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
          setLoading(false);
          setValidated(false);
          setFormData({
            max_imp_red: "1000",
            max_op_red: "250",
            motive: "",
          });
        } else {
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
          setLoading(false);
          setValidated(false);
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
      toast(error.message, {
        icon: <LogoPetroprix />,
      });
      setLoading(false);
      setValidated(false);
    }
  };

  return (
    <Modal
      {...modalProps}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>{t("flotas.modal.limites.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Container>
          <Form
            noValidate
            autoComplete="off"
            onSubmit={(e) => setDailyLimits(e)}
          >
            {/* Importes maximos y nº repostajes diarios */}
            <Row className="">
              <Col sm={12}>
                <Alert variant="primary" className="text-center">
                  {t("flotas.modal.limites.form.info")}
                </Alert>
              </Col>

              <Col sm={12} className="mt-2">
                <FloatingLabel
                  label={t("flotas.modal.limites.form.max_imp_red")}
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    min="0"
                    id="flotas-modal-editar-form-impMaxRepostPetroprix"
                    placeholder={t("flotas.modal.limites.form.max_imp_red")}
                    value={formData.max_imp_red}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        max_imp_red: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.max_imp_red}
                  />
                  {validated && !validateForm.max_imp_red && (
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "flotas.modal.limites.form.validation.max_imp_red.invalid"
                      )}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>

              <Col sm={12}>
                <FloatingLabel
                  label={t("flotas.modal.limites.form.max_op_red")}
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    min="0"
                    id="flotas-modal-editar-form-numRepostDiaPetroprix"
                    placeholder={t("flotas.modal.limites.form.max_op_red")}
                    value={formData.max_op_red}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        max_op_red: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.max_op_red}
                  />
                  {validated && !validateForm.max_op_red && (
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "flotas.modal.limites.form.validation.max_op_red.invalid"
                      )}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>

              {/* Motivo */}
              <Col sm={12}>
                <FloatingLabel
                  label={t("flotas.modal.limites.form.motive")}
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    id="flotas-modal-editar-form-motivo"
                    placeholder={t("flotas.modal.limites.form.motive")}
                    value={formData.motive}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        motive: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.motive}
                  />
                  {validated && !validateForm.motive && (
                    <Form.Control.Feedback type="invalid">
                      {/* Make sure you have a translation key for motivo validation */}
                      {t("flotas.modal.limites.form.validation.motive.invalid")}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>
            </Row>

            <Row>
              <div className="d-grid gap-2 mt-2 ">
                <Button
                  variant="outline-primary"
                  size="lg"
                  onClick={() => {
                    props.onHide(false);
                  }}
                >
                  {t("flotas.modal.limites.form.btn-cancel")}
                </Button>
                <Button
                  variant="primary"
                  size="lg"
                  type="submit"
                  onClick={(e) => setDailyLimits(e)}
                >
                  {t("flotas.modal.limites.form.btn-guardar")}
                </Button>
              </div>
            </Row>
          </Form>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
